import { render, staticRenderFns } from "./c_classify.vue?vue&type=template&id=61b8d51c&scoped=true"
import script from "./c_classify.vue?vue&type=script&lang=js"
export * from "./c_classify.vue?vue&type=script&lang=js"
import style0 from "./c_classify.vue?vue&type=style&index=0&id=61b8d51c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b8d51c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b8d51c')) {
      api.createRecord('61b8d51c', component.options)
    } else {
      api.reload('61b8d51c', component.options)
    }
    module.hot.accept("./c_classify.vue?vue&type=template&id=61b8d51c&scoped=true", function () {
      api.rerender('61b8d51c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_classify.vue"
export default component.exports